import { Capacitor } from '@capacitor/core';
import { config } from './config';

type Platform = 'web' | 'ios' | 'android';

export type PageKey =
  | 'inspecting'
  | 'planning'
  | 'correctiveActions'
  | 'reporting'
  | 'userPreferences'
  | 'moduleSettings'
  | 'userManagement'
  | 'enterpriseManagement';

const isMobilePlatform = (): boolean => {
  const platform = Capacitor.getPlatform() as Platform;
  return platform === 'ios' || platform === 'android';
};

const isWebPlatform = (): boolean => {
  return Capacitor.getPlatform() as Platform === 'web';
};
// Get the exact mode name as a string (e.g., 'development', 'production', 'staging')
const currentMode = import.meta.env.MODE;
const flags =
  currentMode === 'production'
    ? config.prod.featureFlags
    : currentMode === 'staging'
    ? config.staging.featureFlags
    : config.dev.featureFlags;

export const featureFlags = {
  /**
   * Offline Management — Mobile Only.
   * Returns false (feature unavailable) when the mobileOnly flag is active
   * and the app is running in a web browser.
   */
  isOfflineManagementEnabled(): boolean {
    if (flags.offlineManagement.mobileOnly && isWebPlatform()) {
      return false;
    }
    return true;
  },

  /**
   * Reporting — Web Only.
   * Returns false (feature unavailable) when the webOnly flag is active
   * and the app is running on a mobile platform (ios/android).
   */
  isReportingEnabled(): boolean {
    if (flags.reporting.webOnly && isMobilePlatform()) {
      return false;
    }
    return true;
  },

  isPageEnabled(page: PageKey): boolean {
    return flags.pages[page] ?? true;
  },
};

export default featureFlags;
